import { makeStyles, tokens } from '@fluentui/react-components';

export const useImageAnimationStyles = makeStyles({
  animationContainer: {
    marginTop: tokens.spacingVerticalL,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },
  tryAnimationPromptContainer: {
    border: '1px solid',
    borderImageSource: 'linear-gradient(90deg, #22AAF3 0%, #41AB8F 27%, #D1C41E 49.5%, #B958D1 73.5%, #FD9E5F 97.5%)',
    borderImageSlice: 1,
    boxShadow: '0px 1.6px 3.6px 0px #00000021',
    padding: tokens.spacingVerticalL,
  },
  tryAnimationPromptTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
  tryAnimationPromptText: {
    display: 'flex',
    flexDirection: 'column',
  },
  tryAnimationPromptButton: {
    marginLeft: tokens.spacingHorizontalXXXL,
    width: 'fit-content',
  },
  actionButton: {
    alignSelf: 'center',
  },
  animationToggleTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  animationPreview: {
    cursor: 'pointer',
  },
  animationPreviewVideo: {
    width: '100%',
  },
});
